import { ColorEnum } from '@/constants/color'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { StyleProp, View, ViewStyle } from 'react-native'
import { UnistylesVariants, createStyleSheet, useStyles } from 'react-native-unistyles'

interface PillProps {
    children: string
    style?: StyleProp<ViewStyle>
}

const Pill: FC<PillProps & UnistylesVariants<typeof stylesheet>> = ({
    children,
    color = 'primary',
    style,
}) => {
    const { styles } = useStyles(stylesheet, { color })

    return (
        <View style={[styles.container, style]}>
            <Typography.Label numberOfLines={1} style={styles.text}>
                {children}
            </Typography.Label>
        </View>
    )
}

const stylesheet = createStyleSheet({
    container: {
        justifyContent: 'center',
        borderRadius: 4,
        height: 20,
        maxWidth: '100%',
        paddingHorizontal: 8,
        variants: {
            color: {
                primary: {
                    backgroundColor: ColorEnum.EMERALD_700,
                },
                secondary: {
                    backgroundColor: ColorEnum.EMERALD_200,
                },
                warning: {
                    backgroundColor: ColorEnum.YELLOW_200,
                },
                destructive: {
                    backgroundColor: ColorEnum.BRICK_200,
                },
            },
        },
    },
    text: {
        variants: {
            color: {
                primary: {
                    color: ColorEnum.WHITE,
                },
                secondary: {
                    color: ColorEnum.EMERALD_700,
                },
                warning: {
                    color: ColorEnum.YELLOW_600,
                },
                destructive: {
                    color: ColorEnum.BRICK_600,
                },
            },
        },
    },
})

export default Pill
